
import { Component, Vue, Watch } from "vue-property-decorator";
import { SMCases, SMTasksServices } from "@/store";
import { TActions, TTask_Table } from "@/models/tasks";

import { EMPLOYER_TASKS_TAB, EXPERT_TASKS_TABS, EXPERT_TABS } from "@/constants/tasks";
import { DEPENDANT_INSIDE_SERVICE_TYPE } from "@/constants/services";

const VALUE_NAME = "name";
const VALUE_STEP = "step";
const VALUE_PRIORITY = "priority";
const VALUE_START_DATE = "startDate";
const VALUE_END_DATE = "endDate";
const VALUE_ACTION_BY = "actionBy";
const VALUE_STATUS = "status";

@Component({
  components: {
    ToDoTasksTableTabs: () => import("@/modules/Tasks/ToDoTasksTable/ToDoTasksTableTabs.vue"),
  },
})
export default class ExpertTasks extends Vue {
  get isDependantCase() {
    return [DEPENDANT_INSIDE_SERVICE_TYPE].includes(SMCases.caseType);
  }

  get tabValues(): string[] {
    let tabs = EXPERT_TABS;

    if (this.isDependantCase) tabs = tabs.filter((name) => name !== EMPLOYER_TASKS_TAB);

    return tabs;
  }

  get tabNames() {
    if (!this.isDependantCase) return EXPERT_TASKS_TABS;

    return Object.keys(EXPERT_TASKS_TABS).reduce((acc, key) => {
      if (key === EMPLOYER_TASKS_TAB) return acc;

      Object.assign(acc, {
        [key]: EXPERT_TASKS_TABS[key],
      });

      return acc;
    }, {});
  }

  get needsUpdate() {
    return SMCases.tasksTableNeedsUpdate;
  }

  @Watch("needsUpdate")
  async atNeedsUpdate(value: boolean) {
    if (!value) return;

    await this.getTableTasks();

    SMCases.setTasksTableNeedsUpdate(false);
  }

  get tableProps() {
    const {
      headers,
      tabValues,
      tabNames,
      mainItems,
      mainItemsArchived,
      sideItems,
      sideItemsArchived,
      actions,
    } = this;

    return {
      headers,
      tabValues,
      tabNames,
      mainItems,
      mainItemsInactive: mainItemsArchived,
      sideItems,
      sideItemsInactive: sideItemsArchived,
      actions,
      showActions: true,
      countSideItemsInactive: false,
    };
  }

  // TODO: DEV-8986. Refactoring it, find better way;
  get mainItems() {
    // return SMTasksServices.employerTasksToDo;

    return this.isDependantCase
      ? SMTasksServices.candidateTasksToDo
      : SMTasksServices.employerTasksToDo;
  }

  get mainItemsArchived() {
    // return SMTasksServices.employerTasksArchived;

    return this.isDependantCase
      ? SMTasksServices.candidateTasksArchived
      : SMTasksServices.employerTasksArchived;
  }

  get sideItems() {
    return SMTasksServices.candidateTasksToDo;
  }

  get sideItemsArchived() {
    return SMTasksServices.candidateTasksArchived;
  }

  get loading() {
    return SMTasksServices.loading;
  }

  get caseId(): number {
    return Number(this.$route.params.id);
  }

  async getTableTasks() {
    await SMTasksServices.getTableTasksToDo(this.caseId);

    await SMTasksServices.getTableTasksArchived(this.caseId);
  }

  async created() {
    await this.getTableTasks();
  }

  actions: TActions = {
    delete: this.deleteTask,
  };

  headers = [
    {
      text: this.$t("table.headers.name"),
      value: VALUE_NAME,
    },
    {
      text: this.$t("table.headers.step"),
      value: VALUE_STEP,
      filterable: true,
    },
    {
      text: this.$t("table.headers.priority"),
      value: VALUE_PRIORITY,
      sortable: true,
      sortBy: "priority",
    },
    {
      text: this.$t("table.headers.startDate"),
      value: VALUE_START_DATE,
      sortable: true,
      sortBy: "date",
    },
    {
      text: this.$t("table.headers.endDate"),
      value: VALUE_END_DATE,
      sortable: true,
      sortBy: "date",
    },
    {
      text: this.$t("table.headers.actionBy"),
      value: VALUE_ACTION_BY,
      filterable: true,
    },
    {
      text: this.$t("table.headers.status"),
      value: VALUE_STATUS,
    },
  ];

  navigateTask(item: TTask_Table) {
    const { id, status } = item;

    this.$router.push({
      path: `/cases/tasks/${id}`,
      params: { status },
    });
  }

  async deleteTask(id: number) {
    await SMTasksServices.archiveTableTask(id);

    await this.getTableTasks();
  }
}
